var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"language-switcher text-right text-sm-left"},_vm._l((_vm.locales),function(locale){return _c('li',{key:locale.code},[_c('router-link',{key:locale.code,attrs:{"to":("/" + (locale.code))}},[_vm._v("\n            "+_vm._s(locale.name)+"\n        ")])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78229692","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguageSwitcher.vue
// module id = null
// module chunks = 